// extracted by mini-css-extract-plugin
export default {"main":"about_main__yNb7H","picture":"about_picture__MX1P8","fl_spb":"about_fl_spb__2umxR","picture2":"about_picture2__lpo0p","info":"about_info__yWI22"};